module.exports = __webpack_public_path__ + "media/images/blobberstova-0c52cd95714c14d957868b9fada5cd21.webp";